import styled from 'styled-components/macro';

export const SmilesWrapper = styled.div`
  box-sizing: border-box;
  display: flex;
  width: 100%;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  gap: 12px;
`;

export const Item = styled.div<{
  isSelected: boolean; //выбрана именно эта оценка
  requestIsRated: boolean; //оценка уже поставлена
}>`
  box-sizing: border-box;
  width: fit-content;
  padding: 6px 8px;
  font-size: 32px;
  border-radius: 8px;
  cursor: pointer;
  background-color: ${(props) =>
    props.isSelected ? props.theme.colors.primary[50] : props.theme.colors.white};
  opacity: ${(props) => (props.isSelected || !props.requestIsRated ? 1 : 0.4)};

  &:hover {
    background-color: ${(props) =>
      props.requestIsRated && !props.isSelected
        ? props.theme.colors.white
        : props.theme.colors.primary[50]};
  }
`;
